var REDUX_PENDING_EFFECTS = '@@REDUX_PENDING_EFFECTS';
var REDUX_PENDING_EFFECTS_PATCH_EFFECT = '@@REDUX_PENDING_EFFECTS/PATCH_EFFECT';
var REDUX_PENDING_EFFECTS_IGNORED_ACTION_TYPES = '@@REDUX_PENDING_EFFECTS/IGNORED_ACTION_TYPES';
var effectTypes$1 = {
  saga: 'redux-saga',
  promise: 'redux-pending-middleware',
  toolkit: 'redux-toolkit'
};

var selectIsPending = function selectIsPending(state) {
  var pendingState = state[REDUX_PENDING_EFFECTS];
  var effectsEntity = pendingState.effectsEntity;
  var size = Object.keys(effectsEntity).length;
  return size > 0;
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var _typeof$1 = {exports: {}};

(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(_typeof$1));

var _typeof = /*@__PURE__*/getDefaultExportFromCjs(_typeof$1.exports);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

var defaultState = {
  effectsEntity: {},
  ignoredActionTypes: null
};

var pendingReducer = function pendingReducer(state, action) {
  var _a;

  if (state === void 0) {
    state = defaultState;
  }

  if (action.type === REDUX_PENDING_EFFECTS_IGNORED_ACTION_TYPES) {
    return __assign(__assign({}, state), {
      ignoredActionTypes: action.payload
    });
  }

  if (action.type === REDUX_PENDING_EFFECTS_PATCH_EFFECT) {
    var effectsEntity = state.effectsEntity,
        ignoredActionTypes = state.ignoredActionTypes;
    var _b = action.payload,
        effectId = _b.effectId,
        actionType = _b.actionType;

    if (ignoredActionTypes !== null && ignoredActionTypes.includes(actionType)) {
      return state;
    }

    var updatedEffectsEntity = void 0;

    if (effectsEntity[effectId] === undefined) {
      updatedEffectsEntity = __assign(__assign({}, effectsEntity), (_a = {}, _a[effectId] = actionType, _a));
    } else {
      var _c = effectsEntity,
          _d = effectId;
          _c[_d];
          var restEffectsId = __rest(_c, [_typeof(_d) === "symbol" ? _d : _d + ""]);

      updatedEffectsEntity = restEffectsId;
    }

    return __assign(__assign({}, state), {
      effectsEntity: updatedEffectsEntity
    });
  }

  return state;
};

function includePendingReducer(reducers) {
  reducers[REDUX_PENDING_EFFECTS] = pendingReducer;
  return reducers;
}

var getIgnoreActionTypesMiddleware = function getIgnoreActionTypesMiddleware(ignoredActionTypes) {
  return function (_a) {
    var getState = _a.getState,
        dispatch = _a.dispatch;
    return function (next) {
      return function (action) {
        var state = getState();
        var rpeState = state[REDUX_PENDING_EFFECTS];

        if (rpeState.ignoredActionTypes === null && action.type !== REDUX_PENDING_EFFECTS_IGNORED_ACTION_TYPES) {
          dispatch({
            type: REDUX_PENDING_EFFECTS_IGNORED_ACTION_TYPES,
            payload: ignoredActionTypes
          });
        }

        return next(action);
      };
    };
  };
};

function isPromise(value) {
  return value instanceof Promise;
}

var patchEffect = function patchEffect(payload) {
  return {
    type: REDUX_PENDING_EFFECTS_PATCH_EFFECT,
    payload: payload
  };
};

// Borrowed from https://github.com/ai/nanoid/tree/master/non-secure and @reduxjs/toolkit
// This alphabet uses a-z A-Z 0-9 _- symbols.
// Symbols are generated for smaller size.
// -_zyxwvutsrqponmlkjihgfedcba9876543210ZYXWVUTSRQPONMLKJIHGFEDCBA
var url = '-_'; // Loop from 36 to 0 (from z to a and 9 to 0 in Base36).

var i = 36;

while (i--) {
  // 36 is radix. Number.prototype.toString(36) returns number
  // in Base36 representation. Base36 is like hex, but it uses 0–9 and a-z.
  url += i.toString(36);
} // Loop from 36 to 10 (from Z to A in Base36).


i = 36;

while (i-- - 10) {
  url += i.toString(36).toUpperCase();
}

var nanoid = function nanoid(size) {
  if (size === void 0) {
    size = 21;
  }

  var id = ''; // Compact alternative for `for (var i = 0; i < size; i++)`

  while (size--) {
    // `| 0` is compact and faster alternative for `Math.floor()`
    id += url[Math.random() * 64 | 0];
  }

  return id;
};

var pendingPromiseMiddleware = function pendingPromiseMiddleware(_a) {
  var dispatch = _a.dispatch;
  return function (next) {
    return function (action) {
      var promise;
      var data;

      if (action.payload) {
        var payload = action.payload;

        if (isPromise(payload)) {
          promise = payload;
        } else if (isPromise(payload.promise)) {
          promise = payload.promise;
          data = payload.data; // when the promise returned by async function
        } else if (typeof payload === 'function' || typeof payload.promise === 'function') {
          promise = payload.promise ? payload.promise() : payload();
          data = payload.promise ? payload.data : undefined;

          if (!isPromise(promise)) {
            return next(__assign(__assign({}, action), {
              payload: promise
            }));
          }
        } else {
          return next(action);
        }
      } else {
        return next(action);
      }

      var actionType = action.type,
          meta = action.meta;
      var effectId = nanoid();
      var effectType = effectTypes$1.promise;
      var patchEffectPayload = {
        effectId: effectId,
        effectType: effectType,
        actionType: actionType
      };

      var getAction = function getAction(newPayload, isRejected) {
        var nextAction = {
          type: isRejected ? "".concat(actionType, "_REJECTED") : "".concat(actionType, "_FULFILLED")
        };

        if (newPayload !== null && typeof newPayload !== 'undefined') {
          nextAction.payload = newPayload;
        }

        if (meta !== undefined) {
          nextAction.meta = meta;
        }

        if (isRejected) {
          nextAction.error = true;
        }

        return nextAction;
      };

      var handleReject = function handleReject(reason) {
        var rejectedAction = getAction(reason, true);
        dispatch(rejectedAction);
        dispatch(patchEffect(patchEffectPayload));
      };

      var handleFulfill = function handleFulfill(value) {
        if (value === void 0) {
          value = null;
        }

        var resolvedAction = getAction(value, false);
        dispatch(resolvedAction);
        dispatch(patchEffect(patchEffectPayload));
        return {
          value: value,
          action: resolvedAction
        };
      };

      dispatch(patchEffect(patchEffectPayload));
      next(__assign(__assign({
        type: "".concat(actionType, "_PENDING")
      }, data !== undefined ? {
        payload: data
      } : {}), meta !== undefined ? {
        meta: meta
      } : {}));
      return promise.then(handleFulfill, handleReject);
    };
  };
};

var pendingToolkitMiddleware = function pendingToolkitMiddleware(_a) {
  var dispatch = _a.dispatch;
  return function (next) {
    return function (action) {
      var _a;

      var requestId = (_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.requestId;

      if (requestId !== undefined) {
        dispatch(patchEffect({
          effectId: requestId,
          effectType: effectTypes$1.toolkit,
          actionType: action.type
        }));
      }

      return next(action);
    };
  };
};

var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};
var IO =
/*#__PURE__*/
createSymbol('IO');

var undef = function undef(v) {
  return v === null || v === undefined;
};
var notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var func = function func(f) {
  return typeof f === 'function';
};
var channel = function channel(ch) {
  return ch && func(ch.take) && func(ch.close);
};

if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') ;
function check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var effectTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: CANCEL,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
function put(channel$1, action) {
  if (process.env.NODE_ENV !== 'production') {
    if (arguments.length > 1) {
      check(channel$1, notUndef, 'put(channel, action): argument channel is undefined');
      check(channel$1, channel, "put(channel, action): argument " + channel$1 + " is not a valid channel");
      check(action, notUndef, 'put(channel, action): argument action is undefined');
    } else {
      check(channel$1, notUndef, 'put(action): argument action is undefined');
    }
  }

  if (undef(action)) {
    action = channel$1; // `undefined` instead of `null` to make default parameter work

    channel$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1,
    action: action
  });
}

var trackWorker = function trackWorker(worker) {
  return function wrapper(action) {
    var effectId, actionType, effectType, patchEffectPayload;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          effectId = nanoid();
          actionType = action.type;
          effectType = effectTypes$1.saga;
          patchEffectPayload = {
            effectId: effectId,
            effectType: effectType,
            actionType: actionType
          };

          if (!put) {
            throw new Error('trackWorker expects installed redux-saga lib.');
          }

          _a.label = 1;

        case 1:
          _a.trys.push([1, 5,, 7]);

          return [4
          /*yield*/
          , put(patchEffect(patchEffectPayload))];

        case 2:
          _a.sent();

          return [5
          /*yield**/
          , __values(worker(action))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , put(patchEffect(patchEffectPayload))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          _a.sent();
          return [4
          /*yield*/
          , put(patchEffect(patchEffectPayload))];

        case 6:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };
};

var pendingSagaMiddleware = function pendingSagaMiddleware(next) {
  return function (effect) {
    if (effect.type === effectTypes.FORK) {
      var effectArgs = effect.payload.args;
      var sagaWorkerArgIndex = 1;
      effectArgs[sagaWorkerArgIndex] = trackWorker(effectArgs[sagaWorkerArgIndex]);
    }

    return next(effect);
  };
};

var defaultConfigureOptions = {
  promise: false,
  toolkit: false,
  saga: false,
  ignoredActionTypes: []
};
var configurePendingEffects = function configurePendingEffects(configureOptions) {
  if (configureOptions === void 0) {
    configureOptions = defaultConfigureOptions;
  }

  var promise = configureOptions.promise,
      toolkit = configureOptions.toolkit,
      saga = configureOptions.saga,
      ignoredActionTypes = configureOptions.ignoredActionTypes;
  var middlewares = [];
  var sagaOptions = {
    effectMiddlewares: []
  };

  if (ignoredActionTypes === null || ignoredActionTypes === void 0 ? void 0 : ignoredActionTypes.length) {
    middlewares.push(getIgnoreActionTypesMiddleware(ignoredActionTypes));
  }

  if (promise) {
    middlewares.push(pendingPromiseMiddleware);
  }

  if (toolkit) {
    middlewares.push(pendingToolkitMiddleware);
  }

  if (saga) {
    sagaOptions.effectMiddlewares.push(pendingSagaMiddleware);
  }

  return {
    middlewares: middlewares,
    sagaOptions: sagaOptions
  };
};

export { configurePendingEffects, includePendingReducer, selectIsPending };
//# sourceMappingURL=bundle.js.map
